import { Avatar, Chip } from "@mui/material";
import * as React from "react";
import { useLanguage } from "./Language";

export interface LinkedGoogleAccountProps {
  email: string;
  onClickUnlink: () => void;
}

export const LinkedGoogleAccount = ({
  email,
  onClickUnlink,
}: LinkedGoogleAccountProps) => {
  const { translate } = useLanguage();
  return (
    <>
      <Chip
        aria-label={`${translate("linkedGoogleAccount")}: ${email}`}
        aria-description={translate("unlinkGoogleAccountInstructions")}
        label={email}
        color="default"
        variant="outlined"
        onClick={onClickUnlink}
        onDelete={onClickUnlink}
        avatar={
          <Avatar
            src="images/google.png"
            aria-hidden="true"
            alt={translate("linkedGoogleAccount")}
          />
        }
      />
    </>
  );
};
